__turbopack_context__.v({
  "attrLabelMobile": "ProductCompareTable-module-scss-module__UhlQaG__attrLabelMobile",
  "attrRow": "ProductCompareTable-module-scss-module__UhlQaG__attrRow",
  "attrRowLast": "ProductCompareTable-module-scss-module__UhlQaG__attrRowLast",
  "attrValue": "ProductCompareTable-module-scss-module__UhlQaG__attrValue",
  "container": "ProductCompareTable-module-scss-module__UhlQaG__container",
  "dataCell": "ProductCompareTable-module-scss-module__UhlQaG__dataCell",
  "firstImageWrapper": "ProductCompareTable-module-scss-module__UhlQaG__firstImageWrapper",
  "firstProductCol": "ProductCompareTable-module-scss-module__UhlQaG__firstProductCol",
  "firstProductImage": "ProductCompareTable-module-scss-module__UhlQaG__firstProductImage",
  "heading": "ProductCompareTable-module-scss-module__UhlQaG__heading",
  "headingMobile": "ProductCompareTable-module-scss-module__UhlQaG__headingMobile",
  "imageLink": "ProductCompareTable-module-scss-module__UhlQaG__imageLink",
  "imagePlaceholder": "ProductCompareTable-module-scss-module__UhlQaG__imagePlaceholder",
  "imageTag": "ProductCompareTable-module-scss-module__UhlQaG__imageTag",
  "imageWrapper": "ProductCompareTable-module-scss-module__UhlQaG__imageWrapper",
  "labelCell": "ProductCompareTable-module-scss-module__UhlQaG__labelCell",
  "labelCol": "ProductCompareTable-module-scss-module__UhlQaG__labelCol",
  "labelHeaderCell": "ProductCompareTable-module-scss-module__UhlQaG__labelHeaderCell",
  "memberSavings": "ProductCompareTable-module-scss-module__UhlQaG__memberSavings",
  "nameWrapper": "ProductCompareTable-module-scss-module__UhlQaG__nameWrapper",
  "navigation": "ProductCompareTable-module-scss-module__UhlQaG__navigation",
  "pdpColumn": "ProductCompareTable-module-scss-module__UhlQaG__pdpColumn",
  "placeholder": "ProductCompareTable-module-scss-module__UhlQaG__placeholder",
  "priceWrapper": "ProductCompareTable-module-scss-module__UhlQaG__priceWrapper",
  "productCol": "ProductCompareTable-module-scss-module__UhlQaG__productCol",
  "productHeaderCell": "ProductCompareTable-module-scss-module__UhlQaG__productHeaderCell",
  "productImage": "ProductCompareTable-module-scss-module__UhlQaG__productImage",
  "productName": "ProductCompareTable-module-scss-module__UhlQaG__productName",
  "productNameLink": "ProductCompareTable-module-scss-module__UhlQaG__productNameLink",
  "ratingWrapper": "ProductCompareTable-module-scss-module__UhlQaG__ratingWrapper",
  "reviewCount": "ProductCompareTable-module-scss-module__UhlQaG__reviewCount",
  "scrollWrapper": "ProductCompareTable-module-scss-module__UhlQaG__scrollWrapper",
  "srOnly": "ProductCompareTable-module-scss-module__UhlQaG__srOnly",
  "table": "ProductCompareTable-module-scss-module__UhlQaG__table",
});
